import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'm-deep-badge-pulse',
  props: {
    text: { default: '深度计算' },
    showPro: { type: Boolean, default: true }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})